import firebase from 'firebase/app';
import 'firebase/messaging';
console.log("firebase ", firebase);
if ('serviceWorker' in navigator) {
    navigator.serviceWorker.register('./sw.js').then((success) => {
        console.log("sw register successfully")
        callFirebase()
    }, (error) => {
        console.log(" not register successfully")
    });
} else {
    console.log("not present")
}
// import { configFirebase } from "@/store/config/firebaseConfig";
// firebase.initializeApp(configFirebase);

firebase.initializeApp({
    // production
    apiKey: "AIzaSyCmyYTOZlJeEV4riZSvw7qRciWMQ-buKFQ",
    authDomain: "imcl-selfcare.firebaseapp.com",
    databaseURL: "https://imcl-selfcare.firebaseio.com",
    projectId: "imcl-selfcare",
    storageBucket: "imcl-selfcare.appspot.com",
    messagingSenderId: "361777923362",
    appId: "1:361777923362:web:c60692e610f5db931c117b",
    measurementId: "G-XX8NXVHT2J"
})

function callFirebase () {
    console.log('callFirebase')
    let tokengen = "";
    firebase.messaging().requestPermission().then(function () {
        return firebase.messaging().getToken();
    }).then(function (token) {
        console.log("token", token);
        localStorage.setItem("token", (token))
        tokengen = token
    }).catch(function (error) {
        console.log('[App | initAWSMA | Notification | requestPermission | error ]', error);
    })
    let messageNotification = "";
    let createdDate = "";
    let image = "";
    navigator.serviceWorker.addEventListener("message", (message) => {
        navigator.serviceWorker.ready.then(function (registration) {
            console.log(message)

            console.log("message data ", message)
            messageNotification = message.data['firebase-messaging-msg-data'].data.message
            createdDate = message.data['firebase-messaging-msg-data'].data.createddates
            image = message.data['firebase-messaging-msg-data'].data.icon

            const notificationTitle = message.data['firebase-messaging-msg-data'].data.title
            const notificationOptions = {
                body: messageNotification,
                image: image
            };

            if (localStorage.getItem("fcm-data")) {
                let getLocalFcm = JSON.parse(localStorage.getItem("fcm-data"));
                console.log(getLocalFcm);
                getLocalFcm.push({ 'message': messageNotification, 'createddate': createdDate, "image": image });
                localStorage.setItem("fcm-data", JSON.stringify(getLocalFcm))
            }
            else {
                let localfcm = [{ 'message': messageNotification }];
                localStorage.setItem("fcm-data", JSON.stringify(localfcm))
            }

            registration.showNotification(notificationTitle, notificationOptions);
        });
    });
}


// WEBPACK FOOTER //
// ./src/foreGroundMessage.js